import { render, staticRenderFns } from "./Forgot.vue?vue&type=template&id=cab71230&scoped=true"
import script from "./Forgot.vue?vue&type=script&lang=js"
export * from "./Forgot.vue?vue&type=script&lang=js"
import style1 from "./Forgot.vue?vue&type=style&index=1&id=cab71230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab71230",
  null
  
)

export default component.exports